import { z } from "zod";

const demoRoleSchema = z.object({
  role: z.string().trim().min(1),
  label: z.string().trim().min(1),
});

const demoModeEnvelopeSchema = z.object({
  mode: z.literal("demo"),
  roles: z.array(z.unknown()),
});

export type DemoRole = string;

export type SsoMode =
  | { readonly mode: "normal" }
  | {
      readonly mode: "demo";
      readonly roles: ReadonlyArray<{
        readonly role: DemoRole;
        readonly label: string;
      }>;
    };

export function parseSsoMode(value: unknown): SsoMode {
  const envelope = demoModeEnvelopeSchema.safeParse(value);
  if (!envelope.success) return { mode: "normal" };

  const roles = envelope.data.roles.flatMap((item) => {
    const parsed = demoRoleSchema.safeParse(item);
    return parsed.success ? [parsed.data] : [];
  });

  return roles.length > 0 ? { mode: "demo", roles } : { mode: "normal" };
}
